<!-- 物理因素接触限值噪声 -->
<template>
  <div class="tableBoxShadow">
    <h5 :class="['title',{mobileFontSize:$isMobile}]">工作场所噪声职业接触限值</h5>
    <el-table :class="{mobileTable:$isMobile}" border :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="touchDuration" label="接触时间">
      </el-table-column>
      <el-table-column align="center" prop="touchLimit" label="接触限值[dB(A)]">
      </el-table-column>
      <el-table-column align="center" prop="note" label="备注">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        tableData:[]
      }
    },
    created() {
      this.finfNoise()
    },
    methods:{
      async finfNoise(){
        let res = await this.$axios.get(this.$serviceAPI.finfNoise)
        this.tableData = res.data.data
      }
    },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subPage/noise.vue